import { SAVE_USER, UPDATE_USER } from "../actions/actionTypes";
import CookieHelper from "../../Helpers/Cookies";
import { buildAccountKey } from "../../Helpers/accountKey";

const initialState = {
  userData: {},
};

export const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_USER:
      return {
        ...state,
        userData: action.payload,
      };
    case UPDATE_USER:
      let newUser = { ...state.userData, ...action.payload };
      // dbServer#114: persist under the same disambiguated account key the login
      // paths use, so a profile update refreshes the correct per-sandbox cookie.
      CookieHelper.setCookie(
        buildAccountKey(newUser.orgId, newUser.userId, newUser.baseUrl),
        JSON.stringify(newUser)
      );
      return {
        ...state,
        userData: newUser,
      };
    default:
      return state;
  }
};
